import { render, staticRenderFns } from "./ximei_add.vue?vue&type=template&id=6f5e0725&scoped=true&"
import script from "./ximei_add.vue?vue&type=script&lang=js&"
export * from "./ximei_add.vue?vue&type=script&lang=js&"
import style0 from "./ximei_add.vue?vue&type=style&index=0&id=6f5e0725&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e0725",
  null
  
)

export default component.exports